<div class="flex flex-col gap-4 w-full max-w-5xl mx-auto p-4 lg:p-10">
        <div class="text-5xl text-center">
                One Application. Endless Opportunities.
        </div>
        <div class="text-xl text-center">
                Get Matched Today
        </div>
        <mat-card 
        appearance="filled"
        class="flex flex-col gap-4 p-4 lg:p-8 w-full border border-solid border-gray-200">
<img
src="/images/logo/tdusa-logo.png"
alt="Site logo"
class="h-6 lg:h-8 w-auto object-contain"
/>
<div class="flex flex-col w-full text-center">
        
        <div>Skip the job hunt—let the best trucking companies come to you!</div>
        <div class="font-bold">Complete your application now and get matched with high-paying jobs that fit your skills and lifestyle. </div>
</div>


        <app-driver-application-form />
</mat-card>
</div>

